import type { FaireProductEntity } from "../../entity_types/product";

export const p_6wrj95m956: FaireProductEntity = {
  token: "p_6wrj95m956",
  type: "product",
  name: "Elephant - Organic Knit Stuffed Animal Baby Toy",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/801bd8b916408cb3e42ebb19cebdbbbc91e39d7793659d1572c2b8c0983b63bb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d0ee0b4587e27230fef22f7b16e5c1d65f5fb9ef1bf0a7456231d35ab7c64636.jpeg",
    "https://cdn.faire.com/fastly/176ef8ef26f3649487e5ef7f02da9ce832b8d6914ee86cadc9e391e226a2326c.jpeg",
  ],
  priceDollars: 20,
  description:
    'Organic cotton knitted stuffed animal baby toys, soft and cuddly, comforting and soothing for your little ones.\nSize: Approx 8-10" Including Trunk and Tail\n(Body Length - 8", Body Height - 6", Width - 4", Tail Length - 3", Ear Length - 2")\n100% organic cotton outer shell, and poly-fill on the inside.\n\nVIVERANO ORGANIC TOYS:\nQuirky & cuddly collection of organic cotton knit toys for your precious little ones.\nFresh & imaginative designs to bring joy and wonder to babies, kids and even adults.\nGreat for buddy adventures, good company and bedtime snuggles.\nLovingly made by hand using certified organic cotton, safe for hugging & snuggling.\nHeirloom quality, meticulous construction and attention to detail.\nNon-toxic and eco-friendly materials.\nSlight color variations & imperfections may exist making each handmade piece charming and one-of-a-kind.\nEasy care machine washable with cool water and non-toxic detergent, fluff in the dryer for a few minutes and then air dry.\nEthically handcrafted by artisans at a GOTS certified facility in India.',
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:28.235Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
